import styled from 'styled-components';
import { Card } from '../../../CommonComponents/OPL/Card/Card';

export const WorkflowCard = styled(Card)({
  height: 272,
  display: 'grid',
  placeContent: 'center',
});
